import { isSfxMuted } from './xpSound';

/**
 * Mini-synthé WebAudio du Volcan des Nombres (design utilisateur, porté du
 * mockup). Respecte le mute global des effets sonores de l'espace élève
 * (même réglage 🔔 que le quiz). Chaque helper est best-effort : un
 * navigateur sans AudioContext ne casse rien.
 */

let ac = null;

const tone = (f, d, type = 'sine', g = 0.15, when = 0) => {
    if (isSfxMuted()) return;
    try {
        ac = ac || new (window.AudioContext || window.webkitAudioContext)();
        // Politique autoplay (mobiles) : le contexte peut naître suspendu —
        // même reprise que xpSound, sinon le volcan reste muet.
        if (ac.state === 'suspended') { ac.resume?.(); }
        const o = ac.createOscillator();
        const v = ac.createGain();
        o.type = type;
        o.frequency.value = f;
        v.gain.setValueAtTime(g, ac.currentTime + when);
        v.gain.exponentialRampToValueAtTime(0.001, ac.currentTime + when + d);
        o.connect(v);
        v.connect(ac.destination);
        o.start(ac.currentTime + when);
        o.stop(ac.currentTime + when + d);
    } catch { /* no-op : pas d'audio dispo */ }
};

/** Clic d'interface (portail, bouton). */
export const sonClicVolcan = () => tone(420, 0.12, 'triangle', 0.12);

/** Plongée dans le cratère : chute grave. */
export const sonPlongee = () => {
    tone(420, 0.12, 'triangle', 0.12);
    tone(200, 0.9, 'sawtooth', 0.1);
    tone(90, 1.4, 'sawtooth', 0.14, 0.2);
};

/** Pierre du noyau qui s'allume (défi crédité). */
export const sonPierre = () => {
    tone(523, 0.15, 'sine', 0.18);
    tone(659, 0.18, 'sine', 0.18, 0.1);
    tone(784, 0.3, 'sine', 0.18, 0.2);
};

/** Éruption (5/5) : grondement + envolée. */
export const sonEruption = () => {
    for (let i = 0; i < 6; i++) tone(60 + Math.random() * 40, 0.5, 'sawtooth', 0.12, i * 0.08);
    tone(880, 0.6, 'sine', 0.2, 0.5);
    tone(1046, 0.8, 'sine', 0.2, 0.7);
};
